(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["asd-vehicle-finance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('asd-vehicle-finance')) {
    class AsdVehicleFinance extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.config = JSON.parse(this.querySelector('[data-finance-config]').textContent);
        this.price = Number(this.dataset.price) / 100;
        this.currency = new Intl.NumberFormat('en-NZ', { style: 'currency', currency: this.dataset.currency });
        this.number = new Intl.NumberFormat('en-NZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        this.deposit = this.querySelector('[data-finance-deposit]');
        this.term = this.querySelector('[data-finance-term]');
        this.credit = this.querySelector('[data-finance-credit]');
        this.results = this.querySelector('[data-finance-results]');
        this.error = this.querySelector('[data-finance-error]');
        this.scope = this.closest('.js-product') || this.closest('.shopify-section');
        this.addEventListener('input', () => this.calculate(), { signal });
        this.addEventListener('change', () => this.calculate(), { signal });
        if (this.scope) {
          this.scope.addEventListener('on:variant:change', (event) => {
            if (event.target.closest('.js-product') !== this.scope) return;
            this.price = event.detail.variant ? Number(event.detail.variant.price) / 100 : NaN;
            this.calculate();
          }, { signal });
        }
        this.calculate();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      write(attribute, value) {
        this.querySelector(`[data-finance-${attribute}]`).textContent = value;
      }

      calculate() {
        const months = Number(this.term.value);
        const years = Math.floor(months / 12);
        const remainder = months % 12;
        const labels = this.config.labels;
        const termText = [years ? `${years} ${years === 1 ? labels.year : labels.years}` : '', remainder ? `${remainder} ${labels.months}` : ''].filter(Boolean).join(' ');
        this.write('term-label', termText);
        this.term.setAttribute('aria-valuetext', termText);
        this.querySelector('[data-finance-price]').value = Number.isFinite(this.price) ? this.number.format(this.price) : '';

        const deposit = this.deposit.value.trim() === '' ? 0 : Number(this.deposit.value);
        const frequency = this.querySelector('[data-finance-frequency]:checked').value;
        const periods = { weekly: 52, fortnightly: 26, monthly: 12 }[frequency];
        const annualRate = this.config.rates[this.credit.value];
        const invalidDeposit = this.deposit.validity.badInput || !Number.isFinite(deposit) || deposit < 0;
        const missingPrice = !Number.isFinite(this.price) || this.price <= 0;
        const borrow = this.price - deposit;
        let error = missingPrice ? labels.noPrice : invalidDeposit ? labels.invalidDeposit : borrow <= 0 ? labels.noBorrowing : '';
        this.deposit.setAttribute('aria-invalid', String(invalidDeposit || (!missingPrice && borrow <= 0)));
        if (!Number.isFinite(months) || months < 6 || months > 60 || !Number.isFinite(annualRate) || !periods) error = labels.unavailable;
        this.error.textContent = error;
        this.error.hidden = !error;
        this.results.hidden = Boolean(error);
        if (error) return;

        const count = Math.round(months / 12 * periods);
        const rate = annualRate / 100 / periods;
        const financed = borrow + this.config.establishmentFee + this.config.ppsrFee;
        const payment = (rate === 0 ? financed / count : financed * rate / (1 - Math.pow(1 + rate, -count))) + this.config.monthlyFee * 12 / periods;
        const total = payment * count;
        if (!Number.isFinite(payment) || !Number.isFinite(total)) {
          this.error.textContent = labels.unavailable;
          this.error.hidden = false;
          this.results.hidden = true;
          return;
        }
        this.write('payment', this.currency.format(payment));
        this.write('period', labels[frequency]);
        this.write('rate', `${annualRate.toFixed(2)}%`);
        this.write('borrowing', this.currency.format(borrow));
        this.write('total', this.currency.format(total));
        this.write('cost', this.currency.format(total - borrow));
        this.write('establishment', this.currency.format(this.config.establishmentFee));
        this.write('ppsr', this.currency.format(this.config.ppsrFee));
        this.write('account', this.currency.format(this.config.monthlyFee));
      }
    }
    customElements.define('asd-vehicle-finance', AsdVehicleFinance);
  }
  } catch(e) { console.error(e); }
})();

})();
